export default __webpack_public_path__ + "static/media/users.2bdfef81.svg";